module.exports = __webpack_public_path__ + "img/chatelle.cb8c7c8f.png";